import '@babel/polyfill';
import {TweenMax, TimelineMax } from "gsap";
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';



function readMoreContent() {
    if(!document.querySelector('.full-section-vacancies')) return;

    const vacancySections = document.querySelectorAll('.vacancy-section');
    const vacancySectionsArray = Array.from(vacancySections);

    const handleOpenCloseSection = () => {
        vacancySectionsArray.forEach(section => {
            const hiddenContents = section.querySelectorAll('.extra-vacancy-content');
            const hiddenContentsArray = Array.from(hiddenContents);
            const buttonReadMore = section.querySelectorAll('.show-content-btn');
            const buttonReadLess = section.querySelectorAll('.hide-content-btn');
            const buttonReadMoreArray = Array.from(buttonReadMore);
            const buttonReadLessArray = Array.from(buttonReadLess);
            buttonReadMoreArray.forEach((bt, index) => {
                bt.setAttribute('data-more', `content-${index + 1}`);
            });
            buttonReadLessArray.forEach((bt, index) => {
                bt.setAttribute('data-more', `content-${index + 1}`);
            });
            hiddenContentsArray.forEach((content, index) => {
                content.setAttribute('data-more', `content-${index + 1}`);
            });
            for(const btn of buttonReadMoreArray) {
                btn.addEventListener('click', function(e){
                    openReadMoreContent.call(this);
                });
            }

            for(const btn of buttonReadLessArray) {
                btn.addEventListener('click', function(e){
                    closeMoreContent.call(this);
                });
            }

            function openReadMoreContent() {
                const currentButton = this;
                currentButton.classList.add('hide-button');
                const target = currentButton.getAttribute('data-more');
                const filteredArray = hiddenContentsArray.filter(item => {
                    return item.getAttribute('data-more') === target;
                });
                filteredArray.forEach(sec => {
                    sec.classList.add('open-section');
                })
            }

            function closeMoreContent() {
                const currentButton = this;
                buttonReadMoreArray.forEach(btn => {
                    btn.classList.remove('hide-button');
                })
                const target = currentButton.getAttribute('data-more');
                const filteredArray = hiddenContentsArray.filter(item => {
                    return item.getAttribute('data-more') === target;
                });
                filteredArray.forEach(sec => {
                    sec.classList.remove('open-section');
                })
            }
        });
    }
    handleOpenCloseSection();

    const pinVacancySectionOnScroll = () => {
        const controller = new ScrollMagic.Controller({
            globalSceneOptions: {
                // triggerHook: 0,
                duration: "30%",
                triggerHook: 0, 
            }
        });
        
        const sections = document.querySelectorAll(".offer-details-nav");

        if(!Modernizr.touch) {
            for (let i = 0; i < vacancySections.length; i=i+1) {
                new ScrollMagic.Scene({
                        triggerElement: sections[i]
                    })
                    .setPin(sections[i], {pushFollowers: false})
                    .addTo(controller);
            }
        }
        

    }
    pinVacancySectionOnScroll();
}

export {
    readMoreContent
}